/*
|--------------------------------------------------------------------------
| Social: Add To Any
|--------------------------------------------------------------------------
*/

/**
 * @namespace
 */
__gh__webApp.social.addToAny = {

	"init": function() {
		__gh__webApp.common.loadScript({
			"text": "var a2a_config = a2a_config || {};\r\n\r\na2a_config = {\r\n\tprioritize:[\"pinterest\",\"linkedin\",\"reddit\",\"google_plus\",\"email\",\"google_gmail\",\"outlook_com\",\"yahoo_mail\"]\r\n};"
		});

		__gh__webApp.common.loadScript({
			"src": "//static.addtoany.com/menu/page.js",
			"onload":this.bindEvents
		});
	},
	
	
	"callbacks": function(data){
		var trackSocial		= __gh__webApp.utilities.tracker.trackSocial;
			trackSocial.shareButtonClick(data);
		
		//var tracker = __gh__webApp.utilities.tracker;
		// Track shares
        /*tracker.trackSocial({
            'hitType': 'AddToAnyShare',
            'socialNetwork': 'AddToAny',
            'socialAction': data.service,
            'socialTarget': data.url
        });*/
		
	},
	
	"reloadShareButtons": function(){
		a2a.init('page',{
			prioritize:["pinterest","linkedin","reddit","google_plus","email","google_gmail","outlook_com","yahoo_mail"]
		});

	},
	
	
	"bindEvents": function(){
		var thisObj = __gh__webApp.social.addToAny;
		a2a_config = a2a_config || {};
	    a2a_config.callbacks = a2a_config.callbacks || [];
	    a2a_config.callbacks.push({
	        share: function(data) {
	            thisObj.callbacks(data);
	        }
	    });
	}
};